module.exports = __webpack_public_path__ + "img/moose_cointreasure.d08a36d.png";